<template>
<div>
  <div style="height: 40px;margin: 10px 40px">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
  </div>
  <div v-if="indexActive === 0">
    <basic-info :basicObj="servicelistObjAll" @changeEndBasic="changeEndBasic"></basic-info>
  </div>
  <div v-if="indexActive === 1">
    <old-person-disease :diseaseObj="servicelistObjAll" @changeEndDisease="changeEndBasic"></old-person-disease>
  </div>
  <div v-if="indexActive === 2">
    <kinsman-info :kinsmanObj="servicelistObjAll"></kinsman-info>
  </div>
  <div v-if="indexActive === 3">
    <economic-situation :economicObj="servicelistObjAll" @changeEndEconomic="changeEndBasic"></economic-situation>
  </div>
<!--  <div v-if="indexActive === 4">-->
<!--    <nurse-plan :nurseObj="servicelistObjAll" @changeEndNurse="changeEndBasic"></nurse-plan>-->
<!--  </div>-->
  <div v-if="indexActive === 5">
    <note-info :noteObj="servicelistObjAll" @changeEndNote="changeEndBasic"></note-info>
  </div>
<!--  <div v-if="indexActive === 6">-->
<!--    <old-person-coordinate></old-person-coordinate>-->
<!--  </div>-->
  <div v-if="indexActive === 7">
    <old-card-list :infoRow="servicelistObjAll"></old-card-list>
  </div>
  <div v-if="indexActive === 8">
    <old-person-file :infoRow="servicelistObjAll" @changeEnd="changeEndBasic"></old-person-file>
  </div>
</div>
</template>

<script>
import basicInfo from './basicInfo'
import oldPersonDisease from './oldPersonDisease'
import kinsmanInfo from './kinsmanInfo'
import economicSituation from './economicSituation'
import nursePlan from './nursePlan'
import noteInfo from './noteInfo'
import oldPersonCoordinate from './oldPersonCoordinate'
import oldCardList from './oldCardList'
import oldPersonFile from './oldPersonFile'
export default {
  name: 'addOldPersonList',
  components: {basicInfo, oldPersonDisease, kinsmanInfo, economicSituation, nursePlan, noteInfo, oldPersonCoordinate, oldCardList, oldPersonFile},
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    servicelistObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '基本信息'},
        {index: 1, name: '老人病史'},
        {index: 2, name: '联系人信息'},
        {index: 3, name: '经济情况'},
        // {index: 4, name: '护理计划'},
        {index: 5, name: '备注信息'},
        // {index: 6, name: '老人坐标'}
        {index: 7, name: '老年卡'},
        {index: 8, name: '电子归档'}
      ],
      indexActive: 0,
      servicelistObjAll: {
        isJujia: false,
        entityArr: [],
        entityelderlyservice: '',
        treeOrg: [],
        isAdd: true,
        isBtn: false, // 是否接口按钮之后再次点击
        extra_info: '', // 点击按钮之后扩展字段数据
        oldPersonRow: {
          // 基本信息
          id: 0,
          elderly_name: '',
          e_id: 0,
          gender: '',
          nationality: '',
          id_number: '',
          contact_phone_number: '',
          mobile_phone_number: '',
          place_of_origin: '',
          marital_status: '',
          residential_address: '',
          residential_postal_code: '',
          birth_date: '',
          religion: '',
          educational_level: '',
          household_type: '',
          elderly_care_level: '',
          household_address: '',
          household_district_code: '',
          elderly_photo: '',
          social_security_number: '', // 经济情况
          extra_info: {}
        }
      }
    }
  },
  created () {
    this.servicelistObjAll.entityArr = this.servicelistObj.entityArr
    this.servicelistObjAll.entityelderlyservice = this.servicelistObj.entityelderlyservice
    this.servicelistObjAll.treeOrg = this.servicelistObj.treeOrg
    this.servicelistObjAll.isAdd = this.servicelistObj.isAdd
    this.servicelistObjAll.oldPersonRow.e_id = this.$store.state.user.LoginResp.entity_id
    if (this.servicelistObj.oldPersonRow !== '') {
      this.servicelistObjAll.oldPersonRow = this.servicelistObj.oldPersonRow
    }
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    },
    changeEndBasic (obj) {
      if (obj.type === 'close') {
        if (this.servicelistObjAll.isBtn) {
          this.$emit('updateTable')
        }
        this.$emit('change', false)
      } else if (obj.type === 'isBtnBasic') { // 基本信息 点击按钮
        this.servicelistObjAll.isBtn = true
        this.servicelistObjAll.oldPersonRow.id = obj.addEditBasicForm.id
        this.servicelistObjAll.oldPersonRow.elderly_name = obj.addEditBasicForm.elderly_name
        this.servicelistObjAll.oldPersonRow.e_id = obj.addEditBasicForm.e_id
        this.servicelistObjAll.oldPersonRow.gender = obj.addEditBasicForm.gender
        this.servicelistObjAll.oldPersonRow.nationality = obj.addEditBasicForm.nationality
        this.servicelistObjAll.oldPersonRow.educational_level = obj.addEditBasicForm.educational_level
        this.servicelistObjAll.oldPersonRow.id_number = obj.addEditBasicForm.id_number
        this.servicelistObjAll.oldPersonRow.contact_phone_number = obj.addEditBasicForm.contact_phone_number
        this.servicelistObjAll.oldPersonRow.mobile_phone_number = obj.addEditBasicForm.mobile_phone_number
        this.servicelistObjAll.oldPersonRow.place_of_origin = obj.addEditBasicForm.place_of_origin
        this.servicelistObjAll.oldPersonRow.marital_status = obj.addEditBasicForm.marital_status
        this.servicelistObjAll.oldPersonRow.residential_address = obj.addEditBasicForm.residential_address
        this.servicelistObjAll.oldPersonRow.residential_postal_code = obj.addEditBasicForm.residential_postal_code
        this.servicelistObjAll.oldPersonRow.birth_date = obj.addEditBasicForm.birth_date
        this.servicelistObjAll.oldPersonRow.religion = obj.addEditBasicForm.religion
        this.servicelistObjAll.oldPersonRow.household_type = obj.addEditBasicForm.household_type
        this.servicelistObjAll.oldPersonRow.elderly_care_level = obj.addEditBasicForm.elderly_care_level
        this.servicelistObjAll.oldPersonRow.household_address = obj.addEditBasicForm.household_address
        this.servicelistObjAll.oldPersonRow.household_district_code = obj.addEditBasicForm.household_district_code
        this.servicelistObjAll.oldPersonRow.elderly_photo = obj.addEditBasicForm.elderly_photo
        this.servicelistObjAll.oldPersonRow.extra_info = obj.extra_info
        this.$emit('updateTable')
        this.$emit('change', false)
      } else if (obj.type === 'isBtnDisease') { //  老人病史 点击按钮
        this.servicelistObjAll.isBtn = true
        this.servicelistObjAll.oldPersonRow.id = obj.diseaseForm.id
        this.servicelistObjAll.oldPersonRow.extra_info = obj.extra_info
      } else if (obj.type === 'isBtnEconomic') { //  经济情况 点击按钮
        this.servicelistObjAll.isBtn = true
        this.servicelistObjAll.oldPersonRow.id = obj.addEditEconForm.id
        this.servicelistObjAll.oldPersonRow.social_security_number = obj.addEditEconForm.social_security_number
        this.servicelistObjAll.oldPersonRow.extra_info = obj.extra_info
      } else if (obj.type === 'isBtnNurse') { // 护理计划 点击按钮
        this.servicelistObjAll.isBtn = true
        this.servicelistObjAll.oldPersonRow.id = obj.nurseForm.id
        this.servicelistObjAll.oldPersonRow.extra_info = obj.extra_info
      } else if (obj.type === 'isBtnNote') { // 备注信息 点击按钮
        this.servicelistObjAll.isBtn = true
        this.servicelistObjAll.oldPersonRow.id = obj.noteForm.id
        this.servicelistObjAll.oldPersonRow.extra_info = obj.extra_info
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addOldPersonList.vue